import { isAxiosError } from 'axios';
import { ApiError } from './api.error';

export function handleApiError(error: Error): Error | ApiError {
  if (!isAxiosError(error)) {
    return error;
  }

  if (error.response) {
    return new ApiError(error.message, error.response.status, error.response.data.code ?? 'UNKNOWN');
  } else {
    return new ApiError(error.message, 500, 'NO_RESPONSE');
  }
}
